import React from 'react';
import { MarketingArticle } from './marketingArticle.jsx';
import heroImage from '../pictures/Currency.webp';
import converterImage from '../pictures/Money Converter.avif';
import transactionImage from '../pictures/Money transactions.avif';
import userImage from '../pictures/User Blockchain for Money.avif';

export function Money() {
  return (
    <MarketingArticle
      title="Money for Modern Times"
      kicker="Digital currency"
      description="Back-Step Blockchain can support digital money that feels simple for citizens, useful for merchants, and accountable for national systems."
      path="/overview"
      heroImage={heroImage}
      heroAlt="Currency concept"
      primaryAction={{ to: '/publications', label: 'Read the paper' }}
      secondaryAction={{ to: '/contact', label: 'Discuss digital money' }}
      sections={[
        {
          tag: 'Everyday use',
          title: 'Digital money must work at normal shopping speed.',
          image: converterImage,
          imageAlt: 'Money converter concept',
          paragraphs: [
            'A successful national digital currency has to be fast, predictable, and easy to use. Customers should not need wallets, mining fees, or speculative tokens to buy a coffee or pay a bill.',
            'Back-Step Blockchain is designed for high-throughput record keeping, which makes real-time payment systems more practical.',
          ],
        },
        {
          tag: 'Trust and control',
          title: 'The system can protect honest users and discourage misuse.',
          image: transactionImage,
          imageAlt: 'Digital money transactions',
          paragraphs: [
            'Modern digital money should preserve privacy where appropriate while still allowing lawful traceability for serious abuse.',
            'That balance is difficult with anonymous cryptocurrency models. A purpose-built national system can be designed around citizens, merchants, regulators, and visitors from the start.',
          ],
        },
        {
          tag: 'Scale',
          title: 'Large payment volumes need a chain built for volume.',
          image: userImage,
          imageAlt: 'User blockchain for money',
          paragraphs: [
            'Our white paper describes how inventory and transaction records can be organized for a national digital currency.',
            'The business value is straightforward: faster settlement, lower handling cost, better auditability, and a path away from the limitations of cash and legacy crypto.',
          ],
        },
      ]}
    />
  );
}
